const arrs=[
  {
    title:'BMW 宝马汽车',
    name:'BMW',
    val:'宝马汽车',
    src:require('./img/02/1.jpg'),
    isActive:false,
  },

  {
    title:'Alfa Romeo 阿尔法-罗米欧',
    name:'Alfa Romeo',
    val:'阿尔法-罗米欧',
    src:require('./img/02/2.jpg'),
    isActive:false,
  },

  {
    title:'Skoda 斯柯达',
    name:'Skoda',
    val:'斯柯达',
    src:require('./img/02/3.jpg'),
    isActive:false,
  },

  {
    title:'Volkswagen 大众汽车',
    name:'Volkswagen',
    val:'大众汽车',
    src:require('./img/02/4.jpg'),
    isActive:false
  },

  {
    title:'Saab 萨布牌轿',
    name:'Saab',
    val:'萨布牌轿',
    src:require('./img/02/5.jpg'),
    isActive:false,
  },

  {
    title:'Lamborghini 兰博基尼',
    name:'Lamborghini',
    val:'兰博基尼',
    src:require('./img/02/6.jpg'),
    isActive:false,
  },

  {
    title:'Porsche 保时捷',
    name:'Porsche',
    val:'保时捷',
    src:require('./img/02/7.jpg'),
    isActive:false,
  },

  {
    title:'Peugeot 标致',
    name:'Peugeot',
    val:'标致',
    src:require('./img/02/8.jpg'),
    isActive:false,
  },

  {
    title:'Mercedes1 梅赛德斯 奔驰',
    name:'Mercedes1',
    val:'梅赛德斯 奔驰',
    src:require('./img/02/9.jpg'),
    isActive:false,
  },

  {
    title:'Buick 别克汽车',
    name:'Buick',
    val:'别克汽车',
    src:require('./img/02/10.jpg'),
    isActive:false,
  }
];
export default arrs;